import { render, staticRenderFns } from "./Registro.vue?vue&type=template&id=2a92a9b6&scoped=true&lang=pug"
import script from "./Registro.vue?vue&type=script&lang=js"
export * from "./Registro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a92a9b6",
  null
  
)

export default component.exports